module.exports = __webpack_public_path__ + "media/src/images/icons/hamburger-f5933b674765d962a8dbf1d796395acc.svg";